import { Header } from './Header';
import { Footer } from './Footer';
import { Toaster } from '../ui/sonner';
import CookieBanner from '../CookieBanner'; // 👈 AJOUT

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-1 pt-16 md:pt-20">
        {children}
      </main>

      <Footer />

      {/* 👇 AJOUT ICI */}
      <CookieBanner />

      <Toaster position="bottom-right" richColors />
    </div>
  );
};

export default Layout;